import dynamic from "next/dynamic";
 
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));
const IPLMenu = dynamic(() => import("@/component/IPL/IPLMenu"));
const IPLCommonFooter = dynamic(() =>
  import("@/component/IPL/IPLCommonFooter")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
// const WebsiteSchema = dynamic(() =>
//   import("@/component/SeoTags/WebsiteSchema")
// );
// const IPLFAQSchema = dynamic(() => import("@/component/SeoTags/IPLFAQSchema"));
import { schedule } from "@/constants/iplSchedule";
import IPLSponsor from "@/component/IPL/IPLSponser";
import { MasterConfigContext } from "@/context/MasterConfigContext";

const SchedulePage = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  faqData = null,
}) => {
  const [data] = useState(schedule);
  const scheduleData = [];
  const chunkSize = 30;
  for (let i = 0; i < schedule.length; i += chunkSize) {
    scheduleData.push(data.slice(i, i + chunkSize));
  }

  // ads implement
  const router = useRouter();
  const currentPath = router?.asPath?.split("?")[0];
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const [readMore, setReadMore] = useState(true);
  const [scrolled, setScrolled] = useState(true);
  // useEffect(() => {
  //   async function onFirstScroll() {
  //     if (!scrolled) {
  //       setScrolled(true);
  //     }
  //   }

  //   function handleScroll() {
  //     onFirstScroll();

  //     window.removeEventListener("scroll", handleScroll);
  //   }

  //   window.addEventListener("scroll", handleScroll);
  // }, []);
  // ads

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                [300, 250],
                "div-gpt-ad-1659434785315-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
          scrolled &&
            googletag?.cmd.push(function () {
              var INTERSTITIALAd = googletag
                ?.defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                  googletag?.enums.OutOfPageFormat.INTERSTITIAL
                )
                ?.addService(googletag.pubads());
              INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_2_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-3"
              )
              ?.addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);
  }, [scrolled]);
  const masterConfig = useContext(MasterConfigContext);
  const iplKeys = masterConfig["ipl_2025"];

  const title =
    "IPL 2025 Schedule: Full Match Fixtures, Dates, Venues & Time – NewsTak";
  const description =
    "IPL 2025 Schedule: Get the complete IPL 2025 match schedule with team-wise fixtures, dates, venues, and match timings. Get daily updates and today’s IPL match details.";
  const keywords =
    "IPL 2025 Schedule, IPL 2025 Fixtures List, IPL Match Schedule 2025, IPL 2025 Date and Time, Today IPL Match Schedule, IPL 2025 Match Timings, IPL 2025 Venue List, IPL 2025 Team-wise Schedule";
  const canonical = "/sports/ipl/schedule";

  const breadCrumbs = [
    {
      id: "1",
      title: "Sports",
      canonical_url: "/sports",
      amp_url: "",
    },
    {
      id: "2",
      title: "IPL",
      canonical_url: "/sports/ipl",
      amp_url: "",
    },
    {
      id: "3",
      title: "Schedule",
      canonical_url: "/sports/ipl/schedule",
      amp_url: "",
    },
  ];

  return (
    <div>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      {/* <WebsiteSchema /> */}
      {/* <IPLFAQSchema /> */}
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList data={categoryNewsListData?.content} />
      <Breadcrumb breadcrumbList={breadCrumbs} />
      <MGIDAAdsScript delay={true} />
      <div className="mx-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
      </div>

      {iplKeys?.showSponsor && (
        <IPLSponsor color="white" masterConfigKey={iplKeys} />
      )}
      <IPLMenu />
      <section className="py-2 mx-4">
        <h1 className="my-4 font-semibold text-lg">IPL 2025 Schedule</h1>
        <p className={`text-[#323232] text-sm text-left relative inline`}>
          <span className={`${readMore ? "line-clamp-2" : ""}`}>
            22 मार्च से IPL की शुरुआत हुई थी और इसका फाइनल 25 मई को ईडन गार्डन,
            कोलकाता में खेला जाएगा. IPL में इस वर्ष कुल 74 मैच राउंड रॉबिन
            फॉर्मेट में खेले जाएंगे. जिसके बाद टॉप चार टीमों के बीच सेमीफाइनल व
            फाइनल खेला जाएगा. टूर्नामेंट की 10 टीमों के 2 ग्रुप बनाए गए हैं. इस
            तरह की अन्य जानकारियां जैसे कब कौन सा मैच है, कहां होगा किस समय
            होगा. तमाम जानकारियों के लिए हमारे साथ जुड़े.
          </span>
          <span
              onClick={() => {
                setReadMore(prev=>!prev);
              }}
              className="cursor-pointer inline -ml-[0.5px]  text-primary text-sm"
            >
              {readMore?"और देखें >":"< कम देखें"}
            </span>
        </p>
        
        {/* table 1 */}
        {scheduleData?.length && (
          <>
            {scheduleData.map((data, index) => (
              <div key={index} className="overflow-x-auto w-full-mx-4 md:-mx-0">
                {index === 1 && scrolled && (
                  <>
                    <AdSlot300x250
                      divId={"div-gpt-ad-1659434604998-0"}
                      minWidth="300px"
                      minHeight="250px"
                    />

                    <AdSlot728x90
                      divId={"div-gpt-ad-1707804176041-2"}
                      minWidth="720px"
                      minHeight="90px"
                    />
                  </>
                )}
                {index === 2 && scrolled && (
                  <>
                    <AdSlot300x250
                      divId={"div-gpt-ad-1659434785315-0"}
                      minWidth="300px"
                      minHeight="250px"
                    />

                    <AdSlot728x90
                      divId={"div-gpt-ad-1707804176041-3"}
                      minWidth="720px"
                      minHeight="90px"
                    />
                  </>
                )}
                <div
                  className={`flex flex-col gap-0 min-w-[800px] md:min-w-full border bordr-gray-300 md:rounded-lg my-4 ${
                    index == scheduleData?.length - 1 ? "pb-4" : ""
                  }`}
                >
                  <div className="bg-[#0000001A] flex items-center md:rounded-t-lg justify-between gap-2 font-semibold text-sm p-2">
                    <div className="w-[15%] md:w-[10%]">M No</div>
                    <div className="w-[15%] md:w-[10%]">M Day</div>
                    <div className="w-[25%] md:w-[15%]">Date</div>
                    <div className="w-[10%]">Day</div>
                    <div className="w-[20%] md:w-[15%]">Start</div>
                    <div className="w-[60%] md:w-[30%]">Home</div>
                    <div className="w-[60%] md:w-[30%]">Away</div>
                    <div className="w-[30%] md:w-[20%]">Venue</div>
                  </div>
                  {data?.map((item, index) => {
                    return (
                      <>
                        <div
                          key={index}
                          className={`flex items-center justify-between gap-2 text-sm p-2 ${
                            index % 2 != 0 ? "bg-[#F8F9FB]" : ""
                          }`}
                        >
                          <div className="w-[15%] md:w-[10%]">
                            {item["Match No"]}
                          </div>
                          <div className="w-[15%] md:w-[10%]">
                            {item["Match Day"]}
                          </div>
                          <div className="w-[25%] md:w-[15%]">
                            {new Date(item.Date).toLocaleDateString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "2-digit",
                            })}
                          </div>
                          <div className="w-[10%]">{item.Day}</div>
                          <div className="w-[20%] md:w-[15%]">{item.Start}</div>
                          <div className="w-[60%] md:w-[30%]">{item.Home}</div>
                          <div className="w-[60%] md:w-[30%] ">{item.Away}</div>
                          <div className="w-[30%] md:w-[20%]">{item.Venue}</div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            ))}
          </>
        )}

        <IPLCommonFooter
          categoryNewsListData={categoryNewsListData}
          faqData={faqData}
          isMobileDevice={isMobileDevice}
          showAds={false}
          scrolled={scrolled}
        />
        {scrolled && (
          <AdSlot300x250
            divId={"div-gpt-ad-1659435474737-0"}
            minWidth="300px"
            minHeight="250px"
          />
        )}

        {scrolled && (
          <AdSlot728x90
            divId="div-gpt-ad-1659425743360-0"
            minWidth="720px"
            minHeight="90px"
          />
        )}
        <div data-type="_mgwidget" data-widget-id="1584885"></div>
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `window.addEventListener("load", function() {
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        });`,
          }}
        ></script>
      </section>
    </div>
  );
};

export default SchedulePage;
